import Image1 from '../image/testominial/person1.webp';
import Image2 from '../image/testominial/person2.webp';
import Image3 from '../image/testominial/person3.webp';

export const PeopleData =[
    {
        id: 1,
        image: Image1,
        title: "Milica",
        description: "Sve novo, cisto, komforno i udobno. Preporuka i veliki pozdrav od Sase i Milice",

    },
    {
        id: 2,
        image: Image2,
        title: "Kristina",
        description: "Sve nam se dopalo. Izuzetan apartman, cist, prostran, lokacija odlicna",

    },
    {
        id: 3,
        image: Image3,
        title: "Filip",
        description: "Apartman nov, grejanje fantasticno, sve bas kako treba...",

    },
]